<template>
  <div class="app bg-gray">
    <div class="scroll">
      <form class="gwi-form" action @submit.prevent="submitForm">
        <section>
          <ul class="list">
            <li class="ipt-item">
              <input
                type="text"
                class="form-right gwi-ipt my-ipt"
                v-model="userName"
                placeholder="请输入姓名"
                maxlength="20"
              />
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectCardType"
                labelName="证件类型"
                :typeList="cardTypeList"
              ></TypeSelect>
            </li>
            <li class="ipt-item">
              <input
                type="text"
                class="form-right gwi-ipt my-ipt"
                v-model="cardNo"
                placeholder="请输入证件号码"
                maxlength="18"
              />
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectSex"
                labelName="性别"
                :typeList="sexList"
              ></TypeSelect>
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectNationality"
                labelName="国籍"
                :typeList="nationalityList"
              ></TypeSelect>
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectNation"
                labelName="民族"
                :typeList="nationList"
              ></TypeSelect>
            </li>
            <li class="my-ipt-item" v-show="currentSelectCardType.key !== '01'">
              <div class="time">
                <div class="time-title">出生日期</div>
                <div class="time-option" @click="setBirthday">
                  {{ birthday }}
                </div>
              </div>
            </li>
            <li class="ipt-item">
              <input
                type="text"
                class="form-right gwi-ipt my-ipt"
                v-model="phone"
                placeholder="请输入手机号码"
                maxlength="20"
              />
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectMarriage"
                labelName="婚姻状况"
                :typeList="marriageList"
              ></TypeSelect>
            </li>
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectOccupation"
                labelName="职业"
                :typeList="occupationList"
              ></TypeSelect>
            </li>
            <li class="ipt-item">
              <AddressSelect
                labelName="地址选择"
                :select="select"
              ></AddressSelect>
              <!-- <v-distpicker type="mobile"></v-distpicker> -->
            </li>
            <li class="ipt-item">
              <input
                type="text"
                class="form-right gwi-ipt my-ipt"
                v-model="detail"
                placeholder="请输入详细地址"
                maxlength="50"
              />
            </li>
          </ul>
        </section>
        <!-- 提醒区域 -->
        <div class="bottom-tips">
          <p class="f-strongest">请务必填写真实的身份信息，否则可能无法就诊</p>
        </div>
        <section class="voucher-add-footer box">
          <button class="btn-ok" type="button" @click="submitForm">
            申请电子健康卡
          </button>
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import utils from "utils";
import voucherService from "voucher.service";
import nationList from "dict/nation";
import nationalityList from "dict/nationality";
import TypeSelect from "TypeSelect";
import AddressSelect from "AddressSelect";
import VDistpicker from 'v-distpicker';
const checkForm = function (data) {
  if (data.userName === null || data.userName.trim().length === 0) {
    return "姓名不能为空";
  }
  if (data.cardNo === null || data.cardNo.length === 0) {
    return "证号号码不能为空";
  }
  if (data.currentSelectCardType.key === '01') {
    if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(data.cardNo.toUpperCase())) {
      return "身份证号输入有误";
    }
  }
  if (data.currentSelectSex.key === '-1') {
    return "请选择性别";
  }
  if (data.currentSelectCardType.key !== '01' && data.birthday === '') {
    return "出生日期不能为空";
  }
  if (data.phone === null || data.phone.length === 0) {
    return "手机号码不能为空";
  }
  if (!/(^1[3-9]\d{9}$)/.test(data.phone)) {
    return "手机号码输入有误";
  }
  if (data.currentMarriage.key === '-1') {
    return "请选择婚姻状况";
  }
  if (data.currentOccupation.key === '-1') {
    return "请选择职业";
  }
  if (data.select.area === '') {
    return "请选择地址";
  }
  if (data.detail === null || data.detail.trim().length === 0) {
    return "详细地址不能为空";
  }
};
export default {
  components: {
    TypeSelect,
    AddressSelect,
    VDistpicker
  },
  mounted () { },
  data () {
    return {
      cardTypeList: [
        { key: "01", name: "居民身份证" },
        { key: "02", name: "居民户口簿" },
        { key: "03", name: "护照" },
        { key: "04", name: "军官证" },
        { key: "05", name: "驾驶证" },
        { key: "06", name: "港澳居民来往内地通行证" },
        { key: "07", name: "台湾居民来往内地通行证" },
        { key: "99", name: "其他法定有效证件" }
      ],
      sexList: [
        { key: "-1", name: "请选择" },
        { key: "1", name: "男" },
        { key: "2", name: "女" }
      ],
      marriageList: [
        { key: "-1", name: "请选择" },
        { key: "10", name: "未婚" },
        { key: "20", name: "已婚" },
        { key: "30", name: "丧偶" },
        { key: "40", name: "离婚" },
        { key: "90", name: "其他" }
      ],
      occupationList: [
        { key: "-1", name: "请选择" },
        { key: "0", name: "国家机关党群组织、企事业单位负责人" },
        { key: "1", name: "各类专业技术人员" },
        { key: "3", name: "办事人员和有关人员" },
        { key: "4", name: "商业、服务业人员" },
        { key: "5", name: "农、林、牧、渔、水利业生产人员" },
        { key: "6", name: "生产、运输设备操作人员及有关人员" },
        { key: "X", name: "军人" },
        { key: "Y", name: "不便分类的其他从业人员" }
      ],
      nationList: nationList,
      nationalityList: nationalityList,
      userName: "",
      cardNo: "",
      birthday: "",
      phone: "",
      select: { province: '四川省', city: '成都市', area: '彭州市' },
      detail: '',
      currentSelectSex: {},
      currentSelectNation: {},
      currentSelectNationality: {},
      currentSelectCardType: {},
      currentMarriage: {},
      currentOccupation: {}
    };
  },
  methods: {
    submitForm () {
      let errorMsg = checkForm(this);
      if (errorMsg) {
        return utils.alert(errorMsg);
      }
      this.submitRegister();
    },
    selectSex (index) {
      this.currentSelectSex = this.sexList[index];
    },
    selectNation (index) {
      this.currentSelectNation = this.nationList[index];
    },
    selectNationality (index) {
      this.currentSelectNationality = this.nationalityList[index];
    },
    selectCardType (index) {
      this.currentSelectCardType = this.cardTypeList[index];
    },
    selectMarriage (index) {
      this.currentMarriage = this.marriageList[index];
    },
    selectOccupation (index) {
      this.currentOccupation = this.occupationList[index];
    },
    setBirthday () {
      const today = new Date();
      var maxDate = today.format("yyyy-MM-dd");
      today.setMonth(today.getMonth() - 12);
      var minDate = '1900-01-01';
      this.$picker.show({
        type: "datePicker",
        date: this.birthday, //初始化时间
        endTime: maxDate, //截至时间
        startTime: minDate, //开始时间
        onOk: e => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"));
          this.birthday = newDate.format("yyyy-MM-dd");
        }
      });
    },
    handlerChange: function (val) {
      console.log(val);
    },
    /* 提交电子健康卡注册 */
    submitRegister () {
      voucherService
        .registerVoucher({
          name: this.userName,
          gender: this.currentSelectSex.key,
          nation: this.currentSelectNation.key,
          cardType: this.currentSelectCardType.key,
          cardNo: this.cardNo.toUpperCase(),
          nationality: this.currentSelectNationality.key,
          birthday: this.birthday,
          phone: this.phone,
          marriage: this.currentMarriage.key,
          address: this.select.province + this.select.city + this.select.area + this.detail,
          occupation: this.currentOccupation.key
        })
        .then(res => {
          if (res.resultCode !== this.constant.RESULT_SUCCESS) {
            utils.alert(res.resultMsg + "请选择居民户口簿等其他方式重新办理！");
            return;
          }
          utils.alert("申请电子健康卡成功！");
          // 退后两步以返回到办卡之前
          // 如果是从工作号菜单跳转来办卡绑卡的，回到主菜单
          if (
            this.$store.state.paramModule.param.voucherChooseType
              .isFromWechatMenu
          ) {
            this.$store.commit("changeState", "Home");
            this.$router.replace("/");
          } else {
            this.$router.go(-2);
          }
        });
    }
  }
};
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.bottom-tips {
  margin: 0 15px;
}
.voucher-add-footer {
  margin-top: 15px;
}
.my-ipt {
  font-size: 0.35rem !important;
}
.my-ipt-item {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  height: 1rem;
}
.time {
  align-items: center;
  line-height: 1rem;
  display: flex;
  flex-direction: row;
  align-content: flex-start;
}
.time-title {
  flex: 1;
  justify-content: flex-start;
  display: flex;
}
.time-option {
  display: flex;
  justify-content: flex-end;
  height: 1rem;
  text-align: center;
  width: 38%;
  line-height: 1rem;
  border: 1px solid #39c451;
  border-radius: 0.25rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  color: #39c451;
  position: relative;
  font-size: 0.35rem;
  &:before {
    position: absolute;
    content: "";
    height: 0.5rem;
    width: 0.48rem;
    top: 0.25rem;
    left: 0.2rem;
    background-image: url(../../../static/img/icon-calendar.png);
    background-size: 100% 100%;
  }
  &:after {
    position: absolute;
    content: "";
    height: 0.2rem;
    width: 0.35rem;
    right: 0.2rem;
    top: 0.4rem;
    background-image: url(../../../static/img/more_blue_dwon.png);
    background-size: 100% 100%;
  }
  &:nth-child(1) {
    margin-left: 0.45rem;
  }
}
</style>



// WEBPACK FOOTER //
// VoucherRegister.vue?11d0ce44